import type { Practitioner, Reference } from '@medplum/fhirtypes'
import { create } from 'zustand'
import { combine, devtools } from 'zustand/middleware'

export const useImpersonateKnock = create(
  devtools(
    combine(
      {
        impersonatedPractitioner: null as Reference<Practitioner> | null,
      },
      (set) => ({
        impersonate: (
          impersonatedPractitioner: Reference<Practitioner> | null
        ) => set({ impersonatedPractitioner }),
      })
    )
  )
)
